import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

export default function ConversationTimeline({ messages = [], busy = false, containerRef, endRef, reactionRenderer, contentRenderer, minHeight = 360, maxHeight = '58vh', emptyState }) {
  return <Box ref={containerRef} data-workspace-timeline sx={{ minHeight, maxHeight, overflowY: 'auto', p: { xs: 2, sm: 3 }, bgcolor: '#FDFCF8' }}>
    <Stack spacing={1.5}>
      {!messages.length && emptyState}
      {messages.map((message, index) => {
        const isUser = message.role === 'user';
        const hasMeaningfulReaction = Boolean(
          !isUser && message.reaction && message.reaction !== 'neutral'
        );
        const reaction = hasMeaningfulReaction ? reactionRenderer?.(message) : null;
        return <Box
          key={`${message.id || 'message'}-${index}`}
          sx={{
            alignSelf: isUser ? 'flex-end' : 'flex-start',
            maxWidth: '86%',
          }}
        >
          <Box sx={{ px: 2, py: 1.25, borderRadius: isUser ? '20px 20px 5px 20px' : '20px 20px 20px 5px', bgcolor: isUser ? '#DCE8C8' : '#fff', color: '#1F352A', border: isUser ? '1px solid #CBDAB3' : '1px solid #D6DED2', minWidth: 0 }}>
            <Box component="span">
              {contentRenderer?.(message) || <Typography component="span">{message.content}</Typography>}
            </Box>
            {reaction && (
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  ml: 0.75,
                  verticalAlign: 'text-bottom',
                }}
              >
                {reaction}
              </Box>
            )}
          </Box>
        </Box>;
      })}
      {busy && <CircularProgress size={22} sx={{ color: '#6F9654' }} />}
      <div ref={endRef} />
    </Stack>
  </Box>;
}
